import {
    NestedField,
} from 'app/types/form.types'
import {
    Timezone,
} from 'app/enums/label.enums'
import {
    LocationFormFields,
} from '../LocationForm.types'

export const getSeaportFieldDetails = ({
    country,
    getAllowedValues,
}): NestedField<LocationFormFields>[] => {
    return [
        {
            name: 'unloCode',
            required: true,
            componentName: 'InputSingleline',
            labelKey: 'UNLO_CODE',
        },
        {
            name: 'country',
            componentName: 'CountryDataSelector',
            value: country,
            labelKey: 'COUNTRY',
        },
        {
            name: 'timeZone',
            componentName: 'EnumSelector',
            allowedValues: getAllowedValues(Timezone),
            required: true,
            labelKey: 'TIME_ZONE',
        },
    ]
}

export default getSeaportFieldDetails
